// Author lidongxu
// Date 2024-02-22 15:18:36

import * as model from "@/model/sithMes/stool/SithMesStoolPrApplicationRecordModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesStoolPrApplicationRecord(), newFilter)
        .withStates({
            baseModuleUrl: process.env.VUE_APP_SITHMES_STOOL_URL,
            callbackApi: process.env.VUE_APP_SITHMES_PRD_URL + '/sithMesStoolPrApplicationRecord/workflow/complete-feedback',
            processDefinitionKey: "sith_mes_stool_pr_application",
            processBusinessData: Object
        })
        .withMutations({
            setProcessBusinessData(state, data) {
                state.processBusinessData = data
            }
        })
        .buildStore()
